module.exports = __webpack_public_path__ + "img/03_En.faba3458.png";